import PropTypes from 'prop-types';
import classNames from 'classnames';
import VibeIcon from '../../VibeIcon/VibeIcon';
import CellTooltip from './CellTooltip';
import * as color from '../../../sass/color.scss';
import './LabelCell.scss';

function LabelCell({
  className = '',
  style = {},
  background = color.manatee16,
  color = color.manatee,
  value = '',
  tooltip = '',
  icon = null,
  inline = false,
}) {
  return (
    <CellTooltip
      title={tooltip}
      placement="right"
    >
      <div
        className={classNames('LabelCell', className)}
        style={{
          backgroundColor: background,
          color,
          display: inline
            ? 'inline-flex'
            : 'flex',
          ...style,
        }}
      >
        {icon && (
          <VibeIcon
            className="icon"
            icon={icon}
            color={color}
            size={16}
          />
        )}

        <div className="value">
          {value}
        </div>
      </div>
    </CellTooltip>
  );
}

LabelCell.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.string,
  background: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.func,
  inline: PropTypes.bool,
};

export default LabelCell;
